import icons from "./icons.gen.json";

type IconData = { body: string; w: number; h: number };
const SET = icons as Record<string, IconData>;

/**
 * One icon from the bundle (tools/build-icons.mjs). "x" is Fluent 2 Regular,
 * "filled:x" the filled form, "logos:x", "mdi:x" and "flag:x" brand sets.
 * Decorative unless given a label.
 */
// A name missing from the bundle draws an empty box; in development it says so once.
const warned = new Set<string>();
const DEV = !!(import.meta as { env?: { DEV?: boolean } }).env?.DEV;

export function Icon({ name, size = 16, label, className, style }: { name: string; size?: number; label?: string; className?: string; style?: React.CSSProperties }) {
  const icon = SET[name];
  if (!icon && DEV && !warned.has(name)) {
    warned.add(name);
    console.warn(`Icon "${name}" is not in the bundle. Name it in source or in tools/icons.extra.txt, then run npm run icons.`);
  }
  const w = icon ? (size * icon.w) / icon.h : size;
  return (
    <svg
      width={w}
      height={size}
      viewBox={icon ? `0 0 ${icon.w} ${icon.h}` : "0 0 16 16"}
      className={className}
      style={{ flex: "none", ...style }}
      aria-hidden={label ? undefined : true}
      role={label ? "img" : undefined}
      aria-label={label}
      fill="currentColor"
      dangerouslySetInnerHTML={{ __html: icon?.body ?? "" }}
    />
  );
}

/** A country flag from an ISO code, 15 px inline; a country whose flag is not bundled shows its code. */
export function Flag({ code, size = 15 }: { code?: string | null; size?: number }) {
  if (!code) return null;
  const name = `flag:${code.toLowerCase()}-4x3`;
  if (!SET[name]) return <span className="flagcode" aria-label={code.toUpperCase()}>{code.toUpperCase()}</span>;
  return <Icon name={name} size={size * 0.75} style={{ borderRadius: 2 }} label={code.toUpperCase()} />;
}
